import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const PREFIX = 'ConfirmationDialog';

const classes = {
  modal: `${PREFIX}-modal`,
  paper: `${PREFIX}-paper`,
  bottomDiv: `${PREFIX}-bottomDiv`,
  divider1: `${PREFIX}-divider1`,
  divider2: `${PREFIX}-divider2`,
  space: `${PREFIX}-space`,
};

const StyledModal = styled(Modal)(({ theme }) => ({
  [`&.${classes.modal}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.paper}`]: {
    position: 'absolute',
    width: 800,

    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 2),
  },

  [`& .${classes.bottomDiv}`]: {
    textAlign: 'center',
  },

  [`& .${classes.divider1}`]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.divider2}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.space}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const ConfirmationDialog = props => {
  const { title, message, ok, cancel, show } = props;

  if (!show) {
    return null;
  }

  return (
    <StyledModal open={true} className={classes.modal} onClose={cancel}>
      <Paper className={classes.paper}>
        <Typography variant='h3'>{title}</Typography>
        <Divider className={classes.divider1} />

        <Typography>{message}</Typography>

        <Divider className={classes.divider2} />
        <div className={classes.bottomDiv}>
          <Button color='secondary' variant='contained' className={classes.space} onClick={cancel}>
            Отменить
          </Button>
          <Button color='primary' variant='contained' className={classes.space} onClick={ok}>
            {'Ok'}
          </Button>
        </div>
      </Paper>
    </StyledModal>
  );
};

ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  ok: PropTypes.func,
  cancel: PropTypes.func,
  show: PropTypes.bool,
};

export default ConfirmationDialog;
